"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isServer = typeof window === 'undefined';
exports.default = isServer;
//# sourceMappingURL=isServer.js.map